import styled from 'styled-components';

export const StdInputText = styled.div`
  width: 100%;
  flex-shrink: 0;
  max-width: 100%;
  @media (max-width: 1600px) {
    max-width: 100% !important;
  }
`;
export const BoxInput = styled.div`
  position: relative;
`;
export const LabelInput = styled.label`
  display: block;
  width: 100%;
  position: relative;
  color: rgb(0, 14, 38);
`;
export const CounterInput = styled.p`
  color: inherit;
  margin: -0.11em 0px 0.11em;
  font-family: var(--font-family-text, vw-text, Helvetica, Arial, sans-serif);
  font-weight: normal;
  font-size: var(--textappearances-copy100-fontsize);
  line-height: var(--textappearances-copy100-lineheight);
  letter-spacing: var(--textappearances-copy100-letterspacing);
  white-space: nowrap;
`;
export const Legend = styled.p`
  color: rgb(0, 14, 38);
  font-size: 1rem;
  line-height: 120%;
  letter-spacing: calc(-0.02em + 0.02rem);
  margin: 0px;
  padding: 0px;
  visibility: initial;
  display: inline-block;
`;
export const StdRequired = styled.span`
  &::after{
  content: '*';
  position: absolute;
  padding-left: 2px !important;
  color: rgb(0, 30, 80) !important;
  margin-top: -2px;
  }
`;
export const TextInput = styled.input`
  &.neutral {
    width: 100%;
    padding: 8px 0px;
    padding-inline: 0px;
    border: 0px;
    border-radius: 0px;
    background: transparent;
    color: rgb(0, 30, 80);
    outline: none;
    appearance: none;
    font-size: 1rem;
    font-family: inherit;
    box-shadow: rgb(106 118 125) 0px 1px 0px 0px;
    transition: padding 0.15s ease-in-out 0s;
    text-overflow: ellipsis;
  }

  &.warn {
    width: 100%;
    padding: 8px 0px;
    padding-inline: 0px;
    border: 0px;
    border-radius: 0px;
    background: transparent;
    color: rgb(0, 30, 80);
    outline: none;
    appearance: none;
    font-size: var(--textappearances-copy200-fontsize);
    font-family: inherit;
    box-shadow: rgb(228 0 44) 0px 1px 0px 0px;
    transition: padding 0.15s ease-in-out 0s;
  }
  &:focus {
    border-bottom-color: rgb(0, 30, 80);
    color: rgb(0, 30, 80);
    box-shadow: rgb(106 118 125) 0px 2px 0px 0px;
    padding-inline-start: 0px;
    transition: padding 0.15s ease-in-out 0.15s;
  }
`;

export const BoxError = styled.div`
  display: flex;
  flex-direction: row;
  -webkit-box-pack: justify;
  justify-content: space-between;
  padding-top: 4px;
  color: rgb(106, 118, 125);
  gap: 8px;
`;
export const Error = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(228, 0, 44);
  color: rgb(255, 255, 255);
  padding: 0px 4px;
  border-radius: 4px;
  min-height: 24px;
  min-width: 24px;
  margin-bottom: 10px;
  .err {
    color: rgb(255, 255, 255);
    margin: -0.11em 0px 0.11em;
    font-family: var(--font-family-text, vw-text, Helvetica, Arial, sans-serif);
    font-weight: normal;
    font-size: var(--textappearances-copy100-fontsize);
    line-height: var(--textappearances-copy100-lineheight);
    letter-spacing: var(--textappearances-copy100-letterspacing);
  }
`;
export const TextWarning = styled.div`
  display: flex;
  flex-direction: column;
`;
export const Texto = styled.div`
  padding: 5px 0;
  transform: translateY(0px);
  font-size: var(--textappearances-copy100-fontsize);
  color: rgb(0, 30, 80);
  white-space: pre-wrap;
`;
export const StdVisible = styled.div`
  position: absolute;
  right: 0px;
  left: 0px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  display: flex;
  flex-direction: row-reverse;
`;
export const BtVisible = styled.button`
  position: relative;
  width: 44px;
  height: 44px;
  transform: translateX(10px);
  background: transparent;
  padding: 0px;
  border-top: none;
  border-right: none;
  border-left: none;
  border-image: initial;
  line-height: 0;
  cursor: pointer;
  border-bottom: 1px solid transparent;
  border-radius: 50%;
  outline: none;
  appearance: none;
  pointer-events: initial;
  color: rgb(0, 30, 80);
  &:hover::before {
    content: '';
    position: absolute;
    top: 0px;
    left: 0px;
    border-radius: 50%;
    width: 100%;
    height: 100%;
    background-color: rgba(194, 202, 207, 0.2);
    box-shadow: rgba(194, 202, 207, 0.2) 0px 0px 0px;
  }
  &:focus {
    background: rgb(0, 119, 204);
    color: rgb(255, 255, 255);
    border: 2px solid rgb(0, 30, 80);
  }
`;
